import _ from "lodash";

import { getLocalStorageUserProfile } from "./localStorage";

export const getAuthUserPermissions = () => {
  const userProfile = getLocalStorageUserProfile();
  return _.get(userProfile, ["role", "permissions"]);
};
